/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrQrRedemptionFlags
 */
export interface RttrQrRedemptionFlags {
    /**
     * True if the user has redeemed an official MineLab event QR in this segment
     * @type {boolean}
     * @memberof RttrQrRedemptionFlags
     */
    minelab: boolean;
    /**
     * True if the user has redeemed a community Club event QR in this segment
     * @type {boolean}
     * @memberof RttrQrRedemptionFlags
     */
    club: boolean;
}

/**
 * Check if a given object implements the RttrQrRedemptionFlags interface.
 */
export function instanceOfRttrQrRedemptionFlags(value: object): value is RttrQrRedemptionFlags {
    if (!('minelab' in value) || value['minelab'] === undefined) return false;
    if (!('club' in value) || value['club'] === undefined) return false;
    return true;
}

export function RttrQrRedemptionFlagsFromJSON(json: any): RttrQrRedemptionFlags {
    return RttrQrRedemptionFlagsFromJSONTyped(json, false);
}

export function RttrQrRedemptionFlagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrQrRedemptionFlags {
    if (json == null) {
        return json;
    }
    return {
        
        'minelab': json['minelab'],
        'club': json['club'],
    };
}

export function RttrQrRedemptionFlagsToJSON(json: any): RttrQrRedemptionFlags {
    return RttrQrRedemptionFlagsToJSONTyped(json, false);
}

export function RttrQrRedemptionFlagsToJSONTyped(value?: RttrQrRedemptionFlags | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minelab': value['minelab'],
        'club': value['club'],
    };
}

